module.exports = __webpack_public_path__ + "img/sg_qrcode_whatsapp.9e5c502.webp";